import React, { useContext, useEffect, useRef } from "react";
import { Layout, Row } from "antd";
import { RouteComponentProps } from "react-router";
import GroupsList from "@Components/groups/GroupsList";
import Sidebar from "../activity/Sidebar";
import { Header } from "../shared/Header";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
import "@Styles/main.scss";
import AutomationActions from "@Components/shared/AutomationActions";

type IProps = RouteComponentProps & { children: any };

const GroupsLayout: React.FC<IProps> = (props: IProps) => {
    const { Content } = Layout;
    const { ui: uiState } = useContext(MainContext);
    const content = useRef<HTMLDivElement>(null);
    const left = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let scrollY = 0;
        if (uiState?.mode !== ViewMode.mobile) {
            if (content?.current != null && left?.current != null) {
                // Apply scrolling to inner content left
                content.current.addEventListener("scroll", function (e) {
                    const delta = content.current.scrollTop - scrollY;
                    scrollY = content.current.scrollTop;
                    left.current.scrollTop += delta;
                });
            }
        }
    }, [content?.current, left?.current]);

    return (
        <div id="main-layout">
            <Layout style={{ height: "100%" }}>
                <Header />
                <Layout>
                    <Sidebar />
                    <div
                        suppressHydrationWarning={true}
                        id="content-wrapper"
                        ref={content}
                        className="scrolling-content-wrapper"
                    >
                        <Layout
                            id="groups-site-layout"
                            className="site-layout"
                            style={{ display: "flex", flexDirection: "row" }}
                        >
                            {/* TODO: should only be shown to users that have permissions for demo mode */}
                            <AutomationActions />
                            <div
                                id="floating-content-left-groups"
                                ref={left}
                                className="floating-content-left floating-content"
                                style={{
                                    left: "205px",
                                    transition: "all 0.2s",
                                }}
                            >
                                <Row>
                                    <GroupsList key="groups-view-desktop" />
                                </Row>
                            </div>
                            <Content
                                id="main-layout-content"
                                className="main-layout-content"
                                style={uiState.mode === ViewMode.mobile ? { padding: 0 } : null}
                            >
                                {props.children}
                            </Content>
                        </Layout>
                    </div>
                </Layout>
            </Layout>
        </div>
    );
};
export default GroupsLayout;
